<template>
  <a-modal
    :footer="null"
    :width="width"
    :afterClose="handleAfterClose"
    v-model:visible="visible"
    :maskClosable="false"
    :bodyStyle="{ padding: 0 }"
    :class="className"
    centered
  >
    <template #closeIcon>
      <div
        v-if="showCloseBtn"
        class="close-btn"
        ref="close-btn"
        @click="handleClose"
      >
        <CloseOutlined />
      </div>
    </template>
    <div v-if="imgSrcs.length > 0">
      <a-carousel arrows :dots="false">
        <template #prevArrow>
          <div class="custom-slick-arrow" style="left: -40px;zIndex: 1">
            <LeftOutlined />
          </div>
        </template>
        <template #nextArrow>
          <div class="custom-slick-arrow" style="right: -40px">
            <RightOutlined />
          </div>
        </template>

        <div class="img-container" v-for="imgSrc in imgSrcs" :key="imgSrc">
          <!-- height: isAttributeImg
                ? 'calc(100vh - 120px)'
                : 'calc(100vh - 80px)' -->
          <img
            alt="pic"
            :src="imgSrc"
            :style="{
              height: 'calc(100vh - 80px)'
            }"
          />
        </div>
      </a-carousel>
    </div>
    <div v-else class="no-img">{{ $t('common.no_img') }}</div>
  </a-modal>
</template>

<script lang="ts">
import { defineComponent, nextTick } from 'vue';
import {
  CloseOutlined,
  LeftOutlined,
  RightOutlined
} from '@ant-design/icons-vue';

export default defineComponent({
  name: 'PreviewImageModal',
  components: {
    CloseOutlined,
    LeftOutlined,
    RightOutlined
  },
  emits: ['after-close'],
  props: {
    images: {
      type: Array,
      required: true,
      default: () => {
        return [];
      }
    },
    isAttributeImg: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    // const className = this.isAttributeImg
    //   ? 'j-custom-close-fixed'
    //   : 'j-custom-close';
    const className = 'j-custom-close';
    return {
      width: 'calc(100% - 120px)', // this.isAttributeImg ? 1280 : 'calc(100% - 120px)',
      className,
      visible: true,
      imgSrcs: this.images.filter(s => s),
      showCloseBtn: false
    };
  },
  mounted() {
    setTimeout(() => {
      const closeBtn: any = document.querySelector('.ant-modal-close');
      if (closeBtn) {
        closeBtn.style.display = 'block';

        this.showCloseBtn = true;
      }
    }, 400);
  },
  methods: {
    handleClose() {
      const closeBtn: any = document.querySelector('.ant-modal-close');
      if (closeBtn) {
        this.showCloseBtn = false;
        closeBtn.style.display = 'none';
      }
      nextTick(() => {
        setTimeout(() => {
          this.visible = false;
        });
      });
    },
    handleAfterClose() {
      this.$emit('after-close');
    }
  }
});
</script>

<style lang="scss" scoped>
.img-container {
  cursor: pointer;
  img {
    display: inline-block;
    width: 100%;
    object-fit: contain;
  }
}

.no-img {
  text-align: center;
  padding: 20px;
}

.ant-carousel ::v-deep(.slick-slide) {
  overflow: hidden;
}

.ant-carousel ::v-deep(.slick-arrow.custom-slick-arrow) {
  width: 40px;
  height: 40px;
  color: #fff;
  font-size: 25px;
  background-color: $primary-color;
  display: flex !important;
  align-items: center;
  justify-content: center;

  &:hover {
    background-color: $primary-hover-color;
  }
}
.ant-carousel ::v-deep(.custom-slick-arrow:before) {
  display: none;
}
</style>
